import type { IZipValidation } from '@inter-ikea-kompis/types';

import ServiceFetch from '../../utilities/ServiceFetch.js';
import type IDexfZipValidationResponse from './types/IDexfZipValidationResponse.js';

/**
 * This class is used for validating zip code .
 */
export default class DexfZipValidationService {
	private endpoint: string;
	private dexfApiKey: string;

	/**
	 * Constructor.
	 *
	 * @param options Options.
	 * @param options.endpoint Endpoint.
	 * @param options.dexfApiKey DEXF Api key.
	 */
	constructor(options: { endpoint: string; dexfApiKey: string }) {
		this.endpoint = options.endpoint;
		this.dexfApiKey = options.dexfApiKey;
	}

	/**
	 * Fetches the validity of a given zip code.
	 *
	 * @param zipCode ...
	 */
	public async getZipValidation(zipCode: string): Promise<IZipValidation> {
		const options = {
			credentials: <RequestCredentials>'same-origin',
			headers: {
				'dexf-api-key': this.dexfApiKey
			}
		};

		const url = `${this.endpoint.replace(
			'{zipCode}',
			encodeURIComponent(zipCode.replace(/ /g, ''))
		)}`;

		const response = <IDexfZipValidationResponse>await ServiceFetch.json(url, options);

		return response;
	}
}
